var exports = {
  "g4": "InviteModal.module__loadingContainer___TmRHTn",
  "qy": "InviteModal.module__channelSubtitle___TmRHTn",
  "HA": "InviteModal.module__channelName___TmRHTn",
  "p": "InviteModal.module__channelIcon___TmRHTn",
  "ak": "InviteModal.module__inviteButton___TmRHTn",
  "UW": "InviteModal.module__warningContainer___TmRHTn",
  "QW": "InviteModal.module__warningIcon___TmRHTn",
  "i4": "InviteModal.module__warningText___TmRHTn",
  "xr": "InviteModal.module__expirationText___TmRHTn",
  "bv": "InviteModal.module__editLink___TmRHTn",
  "Wm": "InviteModal.module__detailedView___TmRHTn",
  "WT": "InviteModal.module__noChannelContent___TmRHTn",
  "Q9": "InviteModal.module__noChannelIcon___TmRHTn",
  "E_": "InviteModal.module__noChannelText___TmRHTn",
};

module.exports = exports;
